"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from 'react';

// Animated Progress Bar Component
export const AnimatedProgressBar = t0 => {
  const $ = _c(7);
  const {
    value,
    maxValue: t1,
    shouldAnimate: t2
  } = t0;
  const maxValue = t1 === undefined ? 5 : t1;
  const shouldAnimate = t2 === undefined ? false : t2;
  const [animatedWidth, setAnimatedWidth] = useState(0);
  let t3;
  let t4;
  if ($[0] !== maxValue || $[1] !== shouldAnimate || $[2] !== value) {
    t3 = () => {
      if (!shouldAnimate) {
        setAnimatedWidth(0);
        return;
      }
      const targetWidth = value / maxValue * 100;
      const startTime = Date.now();
      let animationFrame;
      const animate = () => {
        const elapsed = Date.now() - startTime;
        const progress = Math.min(elapsed / 600, 1);
        const easeOutCubic = 1 - Math.pow(1 - progress, 3);
        const currentWidth = targetWidth * easeOutCubic;
        setAnimatedWidth(currentWidth);
        if (progress < 1) {
          animationFrame = requestAnimationFrame(animate);
        } else {
          setAnimatedWidth(targetWidth);
        }
      };
      animationFrame = requestAnimationFrame(animate);
      return () => {
        if (animationFrame) {
          cancelAnimationFrame(animationFrame);
        }
      };
    };
    t4 = [value, maxValue, shouldAnimate];
    $[0] = maxValue;
    $[1] = shouldAnimate;
    $[2] = value;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  useEffect(t3, t4);
  const t5 = `${animatedWidth}%`;
  let t6;
  if ($[5] !== t5) {
    t6 = <div className="w-20 h-1.5 bg-gray-200 rounded-full overflow-hidden"><div className="h-full bg-primary-primaryBlue rounded-full transition-all duration-300" style={{
        width: t5
      }} /></div>;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
};

// Animated Counter Component for Scores
export const AnimatedCounter = t0 => {
  const $ = _c(7);
  const {
    targetValue,
    shouldAnimate: t1,
    suffix: t2
  } = t0;
  const shouldAnimate = t1 === undefined ? false : t1;
  const suffix = t2 === undefined ? "%" : t2;
  const [displayValue, setDisplayValue] = useState(0);
  let t3;
  let t4;
  if ($[0] !== shouldAnimate || $[1] !== targetValue) {
    t3 = () => {
      if (!shouldAnimate) {
        setDisplayValue(0);
        return;
      }
      const startTime = Date.now();
      let animationFrame;
      const animate = () => {
        const elapsed = Date.now() - startTime;
        const progress = Math.min(elapsed / 800, 1);
        const easeOutCubic = 1 - Math.pow(1 - progress, 3);
        const currentValue = Math.round(targetValue * easeOutCubic);
        setDisplayValue(currentValue);
        if (progress < 1) {
          animationFrame = requestAnimationFrame(animate);
        } else {
          setDisplayValue(targetValue);
        }
      };
      animationFrame = requestAnimationFrame(animate);
      return () => {
        if (animationFrame) {
          cancelAnimationFrame(animationFrame);
        }
      };
    };
    t4 = [targetValue, shouldAnimate];
    $[0] = shouldAnimate;
    $[1] = targetValue;
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  useEffect(t3, t4);
  let t5;
  if ($[4] !== displayValue || $[5] !== suffix) {
    t5 = <>{displayValue}{suffix}</>;
    $[4] = displayValue;
    $[5] = suffix;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};